import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import { defineStore } from 'pinia';
import { readonly } from 'vue';
import { MaxLvs, LbMaxLvs, sortHeroes } from '@/utils/HeroUtil';
import { useHeroMaster } from '@/stores/useHeroMaster';
import { useAuthStore } from '@/stores/useAuthStore';
import { useSkillMaster } from '@/stores/useSkillMaster';
import { useLandMakeStore } from '@/stores/useLandMakeStore';
import HeroAssetNetworks from '@/assets/contracts/HeroAssetNetworks.json';
export var useHeroStore = defineStore('heroStore', {
  state: function state() {
    return {
      list: [],
      myOwnHeroIds: [],
      myOwnEthHeroIds: [],
      myOwnMaticHeroIds: [],
      myOwnOasysHeroIds: []
    };
  },
  getters: {
    getHero: function getHero(state) {
      return function (id) {
        return readonly(state.list.find(function (item) {
          return item.heroId === id;
        }) || {});
      };
    },
    myOwnHeroes: function myOwnHeroes(state) {
      return sortHeroes(state.list.filter(function (item) {
        return state.myOwnHeroIds.includes(item.heroId);
      }));
    },
    myOwnIds: function myOwnIds(state) {
      return _toConsumableArray(state.myOwnHeroIds);
    },
    myOwnEthIds: function myOwnEthIds(state) {
      return _toConsumableArray(state.myOwnEthHeroIds);
    },
    myOwnMaticIds: function myOwnMaticIds(state) {
      return _toConsumableArray(state.myOwnMaticHeroIds);
    },
    myOwnOasysIds: function myOwnOasysIds(state) {
      return _toConsumableArray(state.myOwnOasysHeroIds);
    },
    getExplorerUri: function getExplorerUri() {
      return function (id) {
        return "".concat(HeroAssetNetworks[useAuthStore().getNetId].address, "/").concat(id);
      };
    },
    getMax: function getMax() {
      return function (rarity) {
        return MaxLvs.find(function (item) {
          return item.rarity === rarity;
        });
      };
    },
    getLbMax: function getLbMax() {
      return function (rarity) {
        return LbMaxLvs.find(function (item) {
          return item.rarity === rarity;
        });
      };
    },
    myOwnEthHeroes: function myOwnEthHeroes(state) {
      return sortHeroes(state.list.filter(function (item) {
        return state.myOwnEthHeroIds.includes(item.heroId);
      }).map(function (item) {
        item.available = false;
        return item;
      }));
    },
    myOwnMaticHeroes: function myOwnMaticHeroes(state) {
      return sortHeroes(state.list.filter(function (item) {
        return state.myOwnMaticHeroIds.includes(item.heroId);
      }).map(function (item) {
        item.available = false;
        return item;
      }));
    },
    myOwnOasysHeroes: function myOwnOasysHeroes(state) {
      return sortHeroes(state.list.filter(function (item) {
        return state.myOwnOasysHeroIds.includes(item.heroId);
      }).map(function (item) {
        item.available = false;
        return item;
      }));
    },
    myOwnDefaultHeroIds: function myOwnDefaultHeroIds() {
      return this.myOwnHeroes.filter(function (h) {
        return [10001, 10002, 10003].includes(h.heroType);
      }).map(function (h) {
        return h.heroId;
      });
    },
    getIsNft: function getIsNft() {
      var _this = this;
      return function (id) {
        var hero = _this.getHero(id);
        return !!hero && hero.artEdited && hero.lv >= 2;
      };
    }
  },
  actions: {
    fetchHero: function fetchHero(id) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var hero, master;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$nuxt.$heroesService.get(id);
            case 2:
              hero = _context.sent;
              master = useHeroMaster().getHeroType(hero.heroType);
              hero = Object.assign({}, master, hero);
              hero.name = master.name;
              hero.filename = master.filename;
              hero.activeSkill = useSkillMaster().getSkillById(hero.active);
              hero.passiveSkill = useSkillMaster().getSkillById(hero.passive);
              hero.originalImageUrl = "".concat(_this2.$nuxt.$env.cdnUrl, "/rsc/unit/").concat(hero.filename, "/unit_ills_thum_").concat(hero.filename, ".png");
              hero.imageUrl = hero.ipfs ? "".concat(_this2.$nuxt.$env.cdnUrl, "/arts/").concat(hero.ipfs) : hero.originalImageUrl;
              _context.next = 13;
              return _this2.$nuxt.$heroesService.getArtEditedHistory(id);
            case 13:
              hero.artHistory = _context.sent;
              _this2.list = _this2.list.filter(function (h) {
                return h.heroId !== hero.heroId;
              });
              _this2.list.push(hero);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchHeroes: function fetchHeroes(ids) {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var force, heroes, fetchids, exploreResultHeroIds, alreadyFetchedIds;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              force = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              heroes = [];
              fetchids = ids;
              if (!force) {
                // 探索完了の時にユニットのレベルが上がる場合はあるので、一旦これで対応(getExporeResultHeroIds)
                exploreResultHeroIds = useLandMakeStore().getExporeResultHeroIds;
                alreadyFetchedIds = _this3.list.filter(function (h) {
                  if (exploreResultHeroIds.includes(h.heroId)) {
                    return h.lv >= _this3.getMax(h.rarity).maxLv;
                  }
                  return true;
                }).map(function (h) {
                  return h.heroId;
                });
                fetchids = ids.filter(function (id) {
                  return !alreadyFetchedIds.includes(id);
                });
              }
              if (!(fetchids.length > 0)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 7;
              return _this3.$nuxt.$heroesService.getAll(fetchids);
            case 7:
              heroes = _context2.sent;
              heroes = heroes.map(function (hero) {
                var master = useHeroMaster().getHeroType(hero.heroType);
                hero = Object.assign({}, master, hero);
                hero.name = master.name;
                hero.filename = master.filename;
                hero.activeSkill = useSkillMaster().getSkillById(hero.active);
                hero.passiveSkill = useSkillMaster().getSkillById(hero.passive);
                hero.originalImageUrl = "".concat(_this3.$nuxt.$env.cdnUrl, "/rsc/unit/").concat(hero.filename, "/unit_ills_thum_").concat(hero.filename, ".png");
                hero.imageUrl = hero.ipfs ? "".concat(_this3.$nuxt.$env.cdnUrl, "/arts/").concat(hero.ipfs) : hero.originalImageUrl;
                hero.artHistory = [];
                return hero;
              });
            case 9:
              heroes.forEach(function (hero) {
                _this3.list = _this3.list.filter(function (h) {
                  return h.heroId !== hero.heroId;
                });
                _this3.list.push(hero);
              });
              if (!heroes.length) {
                _this3.list = _toConsumableArray(_this3.list);
              }
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchMyOwnHeroIds: function fetchMyOwnHeroIds() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var heroIds;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.$nuxt.$heroesService.getMyOwnIds();
            case 2:
              heroIds = _context3.sent;
              _this4.myOwnHeroIds = heroIds;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchMyOwnHeroes: function fetchMyOwnHeroes() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.fetchMyOwnHeroIds();
            case 2:
              _context4.next = 4;
              return _this5.fetchHeroes(_this5.myOwnHeroIds);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // BFHのもので Network上のHeroを取得
    fetchEthHeroIds: function fetchEthHeroIds() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var assets, ethAssets;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.$nuxt.$heroesService.getMyOnchainHeroIds();
            case 2:
              assets = _context5.sent;
              ethAssets = assets.filter(function (asset) {
                return asset.array[1] === 'Ethereum:Mainnet' || asset.array[1] === 'Ethereum:Rinkeby';
              });
              _this6.myOwnEthHeroIds = ethAssets.map(function (a) {
                return a.array[0];
              });
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fetchMaticHeroIds: function fetchMaticHeroIds() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var assets, maticAssets;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.$nuxt.$heroesService.getMyOnchainHeroIds();
            case 2:
              assets = _context6.sent;
              maticAssets = assets.filter(function (asset) {
                return asset.array[1] === 'Matic:Mainnet' || asset.array[1] === 'Matic:Mumbai';
              });
              _this7.myOwnMaticHeroIds = maticAssets.map(function (a) {
                return a.array[0];
              });
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchOasysHeroIds: function fetchOasysHeroIds() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var assets, oasysAssets;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.$nuxt.$heroesService.getMyOnchainHeroIds();
            case 2:
              assets = _context7.sent;
              oasysAssets = assets.filter(function (asset) {
                return asset.array[1] === 'Oasys:Homeverse' || asset.array[1] === 'Oasys:Sandverse';
              });
              _this8.myOwnOasysHeroIds = oasysAssets.map(function (a) {
                return a.array[0];
              });
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // 成長傾向更新
    fetchRefreshedHero: function fetchRefreshedHero(ids) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var hero, master;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this9.$nuxt.$heroesService.refreshParam(ids[0], ids[1]);
            case 2:
              hero = _context8.sent;
              master = useHeroMaster().getHeroType(hero.heroType);
              hero = Object.assign({}, master, hero);
              hero.name = master.name;
              hero.filename = master.filename;
              hero.activeSkill = useSkillMaster().getSkillById(hero.active);
              hero.passiveSkill = useSkillMaster().getSkillById(hero.passive);
              hero.originalImageUrl = "".concat(_this9.$nuxt.$env.cdnUrl, "/rsc/unit/").concat(hero.filename, "/unit_ills_thum_").concat(hero.filename, ".png");
              hero.imageUrl = hero.ipfs ? "".concat(_this9.$nuxt.$env.cdnUrl, "/arts/").concat(hero.ipfs) : hero.originalImageUrl;
              _context8.next = 13;
              return _this9.$nuxt.$heroesService.getArtEditedHistory(ids[0]);
            case 13:
              hero.artHistory = _context8.sent;
              _this9.list = _this9.list.filter(function (h) {
                return h.heroId !== hero.heroId;
              });
              _this9.list.push(hero);
            case 16:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  }
});